import { object, string, number, boolean } from 'yup';

export default object().shape({
  id_estado: number().required('Este campo é obrigatório!'),
  ano_exercicio: number().required('Este campo é obrigatório!'),
  final_placa: number().required('Este campo é obrigatório!'),
  validade_exercicio: string().required('Este campo é obrigatório!'),
  numero_portaria: string().required('Este campo é obrigatório!'),
  ativo: boolean(),
})
